import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { coaches } from 'config';
import { ActionTypes } from 'literals';

import {
  loginSuccess,
  logOutSuccess,
  userAnswerFailure,
  userAnswerSuccess,
  userSpeak,
  userSpeakFailure,
  userSpeakSuccess,
} from 'actions';

export function* loginSaga() {
  yield put(loginSuccess());
}

export function* logoutSaga() {
  yield put(logOutSuccess());
}

export function* userAnswerSaga(): Generator<any, void, any> {
  try {
    const grade = yield select(({ user }) => user.grade);
    const coach = yield select(({ user }) => user.coach);
    const conversationId = yield select(({ user }) => user.conversationId);
    const { chatbotId } = coaches[coach];
    const messages = yield select(({ user }) => user.messages);

    // if (grade === 0 && coach === 0) {
    const response = yield call(fetch, 'https://www.chatbase.co/api/v1/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_CHATBASE_API_KEY}`,
      },
      body: JSON.stringify({
        chatbotId,
        temperature: 0,
        stream: true,
        messages: messages[grade][coach],
        conversationId,
      }),
    });

    /* const data = yield call([response, response.json]);
      const question = data.text as string;

      yield put(userAnswerSuccess(question)); */
    const data = response.body;

    if (!data) {
      return;
    }

    const reader = data.getReader();
    const decoder = new TextDecoder();
    let done = false;
    let first = true;

    while (!done) {
      const { done: doneReading, value } = yield call([reader, reader.read]);

      done = doneReading;
      const chunkValue = decoder.decode(value);

      yield put(userAnswerSuccess(chunkValue, !first));

      if (first === true) {
        first = false;
      }
    }

    const questions = yield select(({ user }) => user.questions);
    const listen = yield select(({ user }) => user.listen);

    if (listen) {
      yield put(userSpeak(questions[grade][coach]));
    }

    // } else {
    //   const response = yield call(fetch, 'https://api.openai.com/v1/chat/completions', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    //     },
    //     body: JSON.stringify({
    //       model: process.env.REACT_APP_OPENAI_CHAT_MODEL,
    //       messages: messages[grade][coach],
    //     }),
    //   });

    //   const data = yield call([response, response.json]);
    //   const question = data.choices[0].message.content as string;

    //   let first = true;

    //   for (const word of question.split(' ')) {
    //     if (first === true) {
    //       yield put(userAnswerSuccess(word));
    //       first = false;
    //     } else {
    //       yield put(userAnswerSuccess(` ${word}`, true));
    //     }

    //     yield delay(20);
    //   }
    // }
  } catch {
    yield put(userAnswerFailure());
  }
}

export function* speak({ payload }: any): Generator<any, void, any> {
  try {
    const coach = yield select(({ user }) => user.coach);
    const { voiceId, voiceSettings } = coaches[coach];

    const response = yield call(fetch, `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'xi-api-key': process.env.REACT_APP_ELEVENLABS_API_KEY,
      } as any,
      body: JSON.stringify({
        text: payload,
        voice_settings: voiceSettings,
      }),
    });
    const data = yield call([response, response.blob]);

    yield put(userSpeakSuccess(URL.createObjectURL(data)));
  } catch {
    yield put(userSpeakFailure());
  }
}

let audio: HTMLAudioElement | null = null;

export function speakPlay({ payload }: any) {
  audio = new Audio(payload);
  audio.play();
}

export function speakPlayPause() {
  audio && audio.pause();
  audio = null;
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.USER_LOGIN_REQUEST, loginSaga),
    takeLatest(ActionTypes.USER_LOGOUT_REQUEST, logoutSaga),
    takeLatest(ActionTypes.USER_ANSWER_REQUEST, userAnswerSaga),
    takeLatest(ActionTypes.USER_SPEAK_REQUEST, speak),
    takeLatest(ActionTypes.USER_SPEAK_SUCCESS, speakPlay),
    takeLatest(ActionTypes.USER_SPEAK_FAILURE, speakPlayPause),
  ]);
}
